// getAllPhysician,
import {physician, exportAutoCaseLog} from '../../../service/service'

export default {
    name: 'automatic-viewing',
    data: function () {
        return {
            data2: [
                {
                    title: 'parent 1',
                    expand: true,
                    children: [
                        {
                            title: 'parent 1-1',
                            expand: true
                        },
                        {
                            title: 'parent 1-2',
                            expand: true
                        }
                    ]
                }
            ],
            total: 0,
            patientName: '',
            dateOfSurgery: ['', ''],
            dateViewed: ['', ''],
            keywordSearch: '',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    key: 'CaseId',tooltip:true
                },
                {
                    title: this.$t('User Viewed'),
                    key: 'UserName',tooltip:true
                },
                {
                    title: this.$t('patient name'),
                    key: 'PatientName',tooltip:true
                },
                {
                    title: this.$t('patient id'),
                    key: 'PatientId',tooltip:true
                },
                {
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'Hospital',tooltip:true
                },
                {
                    title: this.$t('date viewed'),
                    key: 'DateViews',tooltip:true
                },
                {
                    title: this.$t('date of surgery'),
                    key: 'DateOfSurgery',tooltip:true
                },
                {
                    title: this.$t('add note'),
                    slot: 'action',tooltip:true
                },
                {
                    title: this.$t('more info'),
                    slot: 'more',tooltip:true
                }
            ],
            data1: [],
            modal: false,
            modal1: false,
            txtComment: '',
            showDetailModal: false,
            commentList: [1, 1, 1, 1, 1],
            pagesize: 20,
            pageTo: 1,
            page: 1,
            arrTree: [],
            tempTree:[],
            dataInfo: null,
            searchMark: false,
            timeoutId: '',
            chooseRow: [{'caseId': 'caseId'}]
        }
    },
    methods: {
        toCsv() {
            console.log(JSON.stringify(this.chooseRow))
            exportAutoCaseLog({
                "userId": this.token,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        changePatientName() {
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        reloadView() {
            let obj = {
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "startDateViewed": this.dateViewed[0],
                "endDateViewed": this.dateViewed[1],
                "keywordSearch": this.keywordSearch
            }
            if (this.arrTree.length) {
                obj["physicianList"] = JSON.stringify(this.arrTree)
            }
            physician.automatic.getAutomaticData(obj).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    let data = JSON.parse(res.data)
                    console.log(data)
                    this.data1 = data.list
                    // console.log(JSON.parse(data.list))
                    this.total = data.total
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                    //   console.log(this.$refs.elScrol)
                }
            })
        },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        addComment1() {
            this.modal1 = true
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        changePageSize(size) {
            this.page = 1
            this.pagesize = size
            this.pageTo = 1
            this.reloadView()
        },
        showDetail(row) {
            this.tid = row.CaseId
            this.tname = row.name
            let p = {
                userId: this.token,
                id: this.tid
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            physician.automatic.getAutomaticInfo(p).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    let data = JSON.parse(res.data)
                    this.dataInfo = data
                    console.log(data)
                    physician.automatic.getAutomaticComment(p).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide()
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                        }
                    })
                }
            })
        },
        ok1() {
            let userName = localStorage.getItem('userName')
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            physician.automatic.addAutomaticComment({
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }).then(res => {
                let code = parseInt(res.code)
                this.$Spin.hide()
                if (!code) {
                    this.txtComment = ''
                    this.tname = ''
                    let p = {
                        userId: this.token,
                        id: this.tid
                    }
                    physician.automatic.getAutomaticComment(p).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            // let data = res.data
                            console.log(res.data)
                            this.commentList = res.data[0]
                            this.showDetailModal = true
                            this.modal1 = false
                            this.tid = 0
                            this.txtComment = ''
                            this.tname = ''
                        }
                    })
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel1() {
            this.modal1 = false
        },
        ok() {
            let userName = localStorage.getItem('userName')
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            physician.automatic.addAutomaticComment({
                "userId": this.token,
                "id": this.tid,
                "name": userName,
                "count": this.txtComment
            }).then(res => {
                console.log(res)
                this.$Spin.hide()
                let code = parseInt(res.code)
                if (!code) {
                    this.modal = false
                    this.tid = 0
                    this.txtComment = ''
                    this.tname = ''
                    this.reloadView()
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel() {
            this.modal = false
        },
        addComment(row) {
            this.tid = row.CaseId
            this.modal = true
        },
        showDate() {
            // console.log(this.dateOfSurgery)
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        dateChange1(e) {
            // console.log(e)
            this.page = 1
            this.pageTo = 1
            this.dateViewed = e
            this.reloadView()
        },
        dateChange(e) {
            // console.log(e)
            this.page = 1
            this.pageTo = 1
            this.dateOfSurgery = e
            this.reloadView()
        }
    },
    created() {

    },
    mounted() {
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        this.arrTree = [
            {physicianID: this.token}
        ]
        // console.log(token)
        // let arr = []
        // getAllSalesReps({UserUID: this.token}).then(res=>{
        //   res.SalesReps.forEach(i=>{
        //     let obj = {
        //       title: i.SalesName,
        //       expand: true,
        //       children: []
        //     }
        // getAllPhysician({UserUID: this.token}).then(res=>{
        //     console.log(res)
        //     res.Physician.forEach(j=>{
        //         if(j.SalesId === i.SalesId){
        //             let opj1 = {
        //                 id: j.DocId,
        //                 title: j.DocName,
        //                 expand: true
        //             }
        //             obj.children.push(opj1)
        //         }
        //     })
        // })
        //     arr.push(obj)
        //     this.data2 = arr
        //   })
        // })
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        this.reloadView()
    }
}
